import { render, staticRenderFns } from "./ReceivedAmount.vue?vue&type=template&id=29d96d0c&scoped=true&"
import script from "./ReceivedAmount.vue?vue&type=script&lang=js&"
export * from "./ReceivedAmount.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedAmount.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReceivedAmount.vue?vue&type=style&index=1&id=29d96d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d96d0c",
  null
  
)

export default component.exports